/* eslint-disable @typescript-eslint/no-unused-vars */
import { labelFeature } from './protocol-labels.reducer';
import { protocolLabelAdapter } from './labels.state';

const entityAdapters = protocolLabelAdapter.getSelectors();
const { name, reducer, ...selectors } = labelFeature;

export const labelSelectors = {
  ...entityAdapters,
  ...selectors,
};
